const emailAFriendTemplateHtml = ({ formValues }) => {
  const { name, email, message, currentURL, brandName, description } =
    formValues || {};

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Product Recommendation</title>
</head>

<body style="margin:0; padding:0; background-color:#ffffff; font-family:Arial, Helvetica, sans-serif;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#ffffff" style="background-color:#ffffff;">
    <tr>
      <td align="center" style="padding:24px;">
        <table
          width="880"
          cellpadding="0"
          cellspacing="0"
          border="0"
          bgcolor="#ffffff"
          style="width:880px; max-width:880px; border-collapse:collapse; background-color:#ffffff;"
        >
          <!-- Header -->
          <tr>
            <td bgcolor="#2b2b2b" style="background-color:#2b2b2b; padding:40px 35px;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;">
                <tr>
                  <td align="left" valign="middle">
                    <img
                      src="https://images.ctfassets.net/4cf96ugtfo35/11TOcoE1mTStyOsuUSVInQ/82165a14c4413f4ffc7f76d1bcd8ba52/image-20260330-063311.png"
                      alt="Kohler"
                      width="120"
                      height="40"
                      style="display:block; border:0; outline:none; text-decoration:none;"
                    />
                  </td>
                  <td align="right" valign="middle" style="font-size:18px; line-height:24px; color:#d9d9d9; font-weight:400;">
                    Product Recommendation
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Spacer -->
          <tr>
            <td height="48"></td>
          </tr>

          <!-- Body -->
          <tr>
            <td
              bgcolor="#ffffff"
              style="
                background-color:#ffffff;
                padding:0 24px;
                color:#2b2b2b;
                font-size:18px;
                line-height:32px;
              "
            >
              <p style="margin:0 0 36px 0; font-weight:700; color:#2b2b2b;">
                ${name} was browsing the Kohler Plumbing Web site and thought you would be interested.
              </p>

              <p style="margin:0 0 28px 0;">
                <strong style="color:#2b2b2b;">${name} wrote:</strong>
                ${message || ""}
              </p>

              <p style="margin:0 0 28px 0;">
                <strong style="color:#2b2b2b;">Friend Email ID:</strong>
                <a href="mailto:${email || ""}" style="color:#7ea7e6; text-decoration:underline; font-weight:700;">
                  ${email || ""}
                </a>
              </p>

              <p style="margin:0 0 36px 0;">
                <strong style="color:#2b2b2b;">View more about this at:</strong>
                <a href="${currentURL || "#"}" style="color:#7ea7e6; text-decoration:underline; font-weight:700;">
                  ${brandName || ""} ${description || ""}
                </a>
              </p>

              <p style="margin:0 0 22px 0;">Thank you,</p>
              <p style="margin:0 0 24px 0;">Kohler</p>
            </td>
          </tr>

          <!-- Spacer -->
          <tr>
            <td height="18"></td>
          </tr>

          <!-- Footer -->
          <tr>
            <td bgcolor="#2b2b2b" style="background-color:#2b2b2b; padding:20px 24px;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;">
                <tr>
                  <td align="left" valign="middle" style="font-size:14px; line-height:22px; color:#d9d9d9;">
                    <a href="mailto:plumbing@kohler.com?subject=Feedback" style="color:#d9d9d9; text-decoration:underline;">
                      Feedback
                    </a>
                    <span style="padding:0 8px;">/</span>
                    <a href="https://www.corporate.kohler.com/privacy-statement" style="color:#d9d9d9; text-decoration:underline;">
                      Privacy Policy
                    </a>
                    <br />
                    © 2026 Kohler Co.
                  </td>

                  <td align="right" valign="middle">
                    <img
                      src="https://images.ctfassets.net/4cf96ugtfo35/11TOcoE1mTStyOsuUSVInQ/82165a14c4413f4ffc7f76d1bcd8ba52/image-20260330-063311.png"
                      alt="Kohler"
                      width="120"
                      height="40"
                      style="display:block; border:0; outline:none; text-decoration:none;"
                    />
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
  `.trim();
};

export default emailAFriendTemplateHtml;
